
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"icon_password_svg__a","d":"M29 16h3.002C34.197 16 36 17.644 36 19.703v14.594C36 36.356 34.197 38 32.002 38H11.998C9.803 38 8 36.356 8 34.297V19.703C8 17.644 9.803 16 11.998 16H15v-4.988A5.006 5.006 0 0120.002 6h3.996A5.008 5.008 0 0129 11.012V16zm-2-5.021a2.997 2.997 0 00-3.002-2.986h-3.996A2.996 2.996 0 0017 10.979v5.014h10v-5.014zM32.002 36C33.119 36 34 35.202 34 34.247V19.753c0-.955-.881-1.753-1.998-1.753H11.998C10.881 18 10 18.798 10 19.753v14.494c0 .955.881 1.753 1.998 1.753h20.004zM20.999 25.547c-.582-.33-.999-.922-.999-1.624C20 22.86 20.892 22 21.999 22c1.106 0 2.001.86 2.001 1.923 0 .702-.41 1.293-1.002 1.624v3.49c0 .53-.45.963-1 .963-.548 0-.999-.434-.999-.963v-3.49z"}})]),_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"icon_password_svg__b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#icon_password_svg__a"}})]),_c('use',{attrs:{"fill-rule":"nonzero","xlink:href":"#icon_password_svg__a"}}),_c('g',{attrs:{"mask":"url(#icon_password_svg__b)"}},[_c('path',{attrs:{"d":"M0 0h44v44H0z"}})])])])
          )
        }
      }
    